import { SUPPORTED_LANGUAGES, RTL } from 'arbitrip-common/translation/const';

// The OneTrust SDK is loaded from public/index.html so that OtAutoBlock.js runs before the
// analytics tags in <head>. This module only reads the resulting consent state.

function hasUserApprovedCookies() {
  const cookie = document.cookie
    .split("; ")
    .find(c => c.startsWith("OptanonActiveGroups="));

  if (!cookie) return false;

  const cookieValue = decodeURIComponent(cookie.split("=")[1]);
  return cookieValue.includes("C0002") || 
         cookieValue.includes("C0003") || 
         cookieValue.includes("C0004"); 
}
  function getCookiesLng(direction){
    return direction.toString().toLowerCase() === RTL ? SUPPORTED_LANGUAGES.HE : SUPPORTED_LANGUAGES.EN;
}

export {hasUserApprovedCookies,getCookiesLng};